import { useMemo } from "react";
import { useParams, Navigate } from "react-router-dom";
import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";
import { Contact } from "@/components/Contact";
import { ServiceHero } from "@/components/service/ServiceHero";
import { ServiceIncludes, ServiceForWhom, ServiceSteps, ServiceFaq, RelatedServices } from "@/components/service/ServiceSections";
import { getServicePage, SITE_URL } from "@/lib/servicePages";
import { useLenis } from "@/lib/useLenis";
import { useSeo } from "@/lib/useSeo";
import { useLang } from "@/lib/i18n";
import { CONTACTS } from "@/lib/content";

const buildJsonLd = (page, ts) => ({
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Service",
      name: page.title,
      description: page.description,
      url: `${SITE_URL}/uslugi/${page.slug}`,
      serviceType: page.title,
      areaServed: { "@type": "Country", name: ts.country },
      provider: {
        "@type": "AccountingService",
        name: ts.firmName,
        url: `${SITE_URL}/`,
        telephone: CONTACTS.phone.replace(/\s/g, ""),
        email: CONTACTS.email,
        address: { "@type": "PostalAddress", streetAddress: "бул. „Дунав“ 196А, офис 7", addressLocality: "Пловдив", addressCountry: "BG" },
      },
    },
    {
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: ts.home, item: `${SITE_URL}/` },
        { "@type": "ListItem", position: 2, name: ts.all, item: `${SITE_URL}/uslugi` },
        { "@type": "ListItem", position: 3, name: page.title, item: `${SITE_URL}/uslugi/${page.slug}` },
      ],
    },
    {
      "@type": "FAQPage",
      mainEntity: page.faqs.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
    },
  ],
});

const ServiceContent = ({ page }) => {
  useLenis();
  const { t } = useLang();
  const jsonLd = useMemo(() => buildJsonLd(page, t.service), [page, t.service]);
  useSeo({ title: page.seoTitle, description: page.description, canonical: `${SITE_URL}/uslugi/${page.slug}`, jsonLd });

  return (
    <div data-testid={`service-page-${page.id}`} className="bg-ink text-mist font-sans antialiased">
      <Nav />
      <main>
        <ServiceHero page={page} />
        <ServiceIncludes page={page} />
        <ServiceForWhom page={page} />
        <ServiceSteps page={page} />
        <ServiceFaq page={page} />
        <RelatedServices page={page} />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default function ServicePage() {
  const { slug } = useParams();
  const { lang } = useLang();
  const page = getServicePage(slug, lang);
  if (!page) return <Navigate to="/uslugi" replace />;
  return <ServiceContent key={page.id} page={page} />;
}
